import { Component } from '@theme/component';

/**
 * A custom element that crossfades between a set of images on a timer.
 *
 * @extends Component
 */
export class RotatingImageComponent extends Component {
  /** @type {number | null} */
  #interval = null;
  #index = 0;

  connectedCallback() {
    super.connectedCallback();

    const images = this.#images;
    if (images.length < 2) return;

    const seconds = Number(this.getAttribute('interval')) || 5;
    this.#interval = window.setInterval(() => this.#advance(), seconds * 1000);
  }

  disconnectedCallback() {
    if (this.#interval !== null) window.clearInterval(this.#interval);
  }

  get #images() {
    return /** @type {HTMLElement[]} */ (Array.from(this.querySelectorAll('.rotating-image__slide')));
  }

  #advance() {
    const images = this.#images;
    images[this.#index]?.classList.remove('rotating-image__slide--active');
    this.#index = (this.#index + 1) % images.length;
    images[this.#index]?.classList.add('rotating-image__slide--active');
  }
}

customElements.define('rotating-image-component', RotatingImageComponent);
